<template>
  <div style="text-align: left; display: flex; flex-direction: row; justify-content: space-between; align-items: center;  border: 0px solid #383838;">    
   
    <div style="display: flex; flex-direction: row; justify-content: flex-start; align-items: flex-start;">    
    <a v-if="isProductionOnly && isMobileDevice" href="javascript:void(0)" style="font-size: 24px; color: black;" @click="handleRouteChange('homepage')">
      <img src="../assets/eta-small.png" alt="" style="width: 50px; top: -5px; position: relative;">
    </a>
    <a v-else-if="isMobileDevice" href="javascript:void(0)" style="font-size: 34px; left: 20px; top: 5px; position: relative; color: black;" @click="displayMenu"><i class="el-icon-menu"></i></a>
    <el-menu 
      v-if="!isOnlyOrderProgressWindow"
      :mode="isMobileDevice ? 'vertical' : 'horizontal'" 
      @select="handleSelect" 
      :style="'margin-top: -10px; '+(isMobileDevice ? 'z-index: 999; position: absolute; top: 80px; left: 0px; width: 300px; box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);' : '')">
      <el-menu-item v-if="show_menu" index="homepage"><img :src="getTopLogo" alt="" style="width: 50px; top: -5px; position: relative;"></el-menu-item>
      <el-submenu 
        v-if="show_menu"
        v-for="(mainMenu, index) in $store.getters.getAccessibleMenu"
        :key="index"
        :index="index+''" 
        style="font-size: 12px; font-weight: 500;">
        <template slot="title">{{mainMenu.menu_name}}</template>
          
            <el-submenu 
                v-for="(subMenu, subIndex) in mainMenu.sub_menu"
                :key="subIndex+'_sub'"
                v-if="subMenu.has_sub_menu"
                :index="subMenu.id+''"
                style="text-align: left;">
                <template slot="title">{{subMenu.menu_name}}</template>
                <el-menu-item 
                    v-for="(subSubMenu, subSubIndex) in subMenu.sub_sub_menu"
                    :key="subSubIndex+'_subSub'"
                    :router="true"
                    v-if="(subSubMenu.id === 204 && !$store.state.preferences.props.tax_return_on_order) || subSubMenu.id != 204"
                    :index="subSubMenu.route_path" style="text-align: left;">
                    <span>
                      {{subSubMenu.menu_name}} 
                    </span>
                </el-menu-item>
            </el-submenu>
            
            <el-menu-item 
                v-else
                :router="true"
                :index="subMenu.route_path" style="text-align: left;">
                <span>
                  {{subMenu.menu_name}}
                </span>
            </el-menu-item>          
      </el-submenu>
      <el-submenu 
          v-if="show_menu && !isProductionOnly"
          style="text-align: left;">
          <template slot="title">Help</template>
          <el-menu-item index="reachus" style="text-align: left;"><a href="https://reachus.easytailorapp.com" target="_blank" style="color: black;">Support &amp; Documentation</a></el-menu-item>
          <el-menu-item index="reachus" style="text-align: left;"><a href="https://billing.stripe.com/p/login/7sIfZha5z92018c9AA" style="color: black;" target="_blank">Billing Portal</a></el-menu-item>
          <el-menu-item index="reachus" style="text-align: left;">Ver. 4.41.7</el-menu-item>
      </el-submenu>
    </el-menu>
    </div>
    
    <div style="display: flex; flex-direction: row; justify-content: flex-end; align-items: flex-end;">
      <el-menu 
        mode="horizontal" 
        @select="handleSelect" 
        style="margin-top: -10px;">
       <!-- <el-menu-item index="addtask">Task<i class="el-icon-date" style="font-size: 18px; position: relative;"></i></el-menu-item>-->
        <el-menu-item index="stocksearch">Search <i class="el-icon-search" style="font-size: 18px; position: relative;"></i></el-menu-item>
        <el-submenu 
          :index="'settings'"
          style="font-size: 12px; font-weight: bold; color: black;">
          <template slot="title"><img :src="$store.getters.getUserInformation.profile_photo" alt="" style="max-width: 20px; border-radius: 50%;"><span style="margin-left: 5px;">{{$store.getters.getUserInformation.name}}</span></template>
            <!--<el-menu-item 
              v-if="getCurrentRoute.split('/').length>1"
              :router="true"
              :index="'calendar'" style="text-align: left;">
              Add To Shortcut
            </el-menu-item>-->
            <el-menu-item 
              :router="true"
              :index="'/tasks'" style="text-align: left;">
              Tasks
            </el-menu-item>
            <el-menu-item 
              v-if="checkIfModuleAccessAvailable('/salesorders', 'can_view')"
              :router="true"
              :index="'salesCalendar'" style="text-align: left;">
              Sales Calendar
            </el-menu-item>
            <el-menu-item 
              v-if="checkIfModuleAccessAvailable('/productionworkorders', 'can_view')"
              :router="true"
              :index="'productionCalendar'" style="text-align: left;">
              Production Calendar
            </el-menu-item>
            <el-menu-item 
              :router="true"
              :index="'/changepassword'" style="text-align: left;">
              Change Password
            </el-menu-item>
            <el-menu-item 
              :router="true"
              :index="'/logout'" style="text-align: left;">
              Logout
            </el-menu-item>           
        </el-submenu>
      </el-menu>
    </div>

    <el-dialog
        v-if="show_calendar"
        :title="'Calendar'"
        fullscreen
        :visible.sync="show_calendar"
        append-to-body>
            <TaskCalendar :production_calendar="isProductionCalendar"/>
    </el-dialog>

    <el-dialog
        v-if="getDaysLeft<=7"
        width="600px"
        :visible.sync="show_renew">
            <AccountExpired :days_left="getDaysLeft"/>
    </el-dialog>

    <el-dialog
        v-if="show_stock_search"
        width="400px"
        :visible.sync="show_stock_search">
            <StockCheck @closed="show_stock_search=false" />
    </el-dialog>

    <el-dialog
        v-if="$store.state.tasks.show_task_form"
        :fullscreen="isMobileDevice"
        :title="'New Task'"
        :width="isMobileDevice ? '100%' : '450px'"
        :visible.sync="$store.state.tasks.show_task_form"
        append-to-body>
            <TaskForm />
    </el-dialog>

  </div>
</template>

<script>
import AccountExpired from '../views/AccountExpired/Index.vue'
import StockCheck from '../views/StockCheck/Index.vue'
import { isMobile, isMobileOnly } from 'mobile-device-detect';
import TaskForm from '../views/Tasks/TaskForm.vue'

export default {
  props: ['isOnlyOrderProgressWindow'],
  components: {AccountExpired, StockCheck, TaskForm},
    data() {
      return {
        activeIndex: '1',
        show_calendar: false,
        production_calendar: false,
        show_renew: true,
        show_menu: false,
        show_stock_search: false,
        current_path: '/'
      }
    },
    computed: {
      isProductionOnly() {
        return this.$store.getters.getUserInformation.is_production_member && (!this.$store.getters.getUserInformation.is_a_production_supervisor && !this.$store.getters.getUserInformation.is_qc_manager)
      },
      getTopLogo() {
        let retailLogo = ''
        this.$store.getters.getAccessibleStoreList.forEach(element => {
            if(element.retail) {
              if(retailLogo === null) {
                retailLogo = element.brand_logo
              } else if(retailLogo.length === 0) {
                retailLogo = element.brand_logo
              }
            }              
        })
        if(retailLogo.length === 0) {
            retailLogo = 'https://etacdn.b-cdn.net/eta-small.png'
        }
        localStorage.setItem('default_logo', retailLogo)
        return retailLogo
      },
      getCurrentHostName() {
        return window.location.hostname
      },
      isHomeDomain() {
        return this.getCurrentHostName.includes('cloud.easytailor') || this.getCurrentHostName.includes('localhost')
      },
      getDaysLeft() {
        return this.$store.state.master.days_left
      },
      isMobileDevice() {
        return isMobile
      },
      isMobileDeviceOnly() {
        return isMobileOnly
      },
      getCurrentRoute() {
        return this.current_path
      },
      isProductionCalendar() {
        return this.production_calendar
      }
    },
    methods: {
        newTask() {
            this.$store.commit('resetTaskData')
            this.$store.commit('resetTaskGroupData')
            this.$store.state.tasks.show_task_form = true
        },
        displayMenu() {
          if(this.isMobileDevice) {
            this.show_menu = !this.show_menu
          } else {
            this.show_menu = true
          }
        },
        handleSelect(key) {
            this.handleRouteChange(key)
        },
        handleRouteChange(routePath) {
        this.current_path = routePath
        this.displayMenu()
        let breadcrumbs = []
        if(routePath == "homepage") {
            breadcrumbs.push({
              crumbName: 'Dashboard'
            })
            this.$store.commit('appendBreadcrumbs', breadcrumbs)
            this.$router.replace('/')
            this.$store.commit('setAccessRights', {id: 0})
        } else if(routePath == '/logout') {
            this.displayMenu()
            this.logout()
        } else if(routePath == '/changepassword') {
            this.displayMenu()
            breadcrumbs.push({
              crumbName: 'Change Password'
            })
            this.$store.commit('appendBreadcrumbs', breadcrumbs)
            this.$router.replace('/changepassword')
        } else if(routePath == '/tasks') {
            this.displayMenu()
            breadcrumbs.push({
              crumbName: 'Tasks'
            })
            this.$store.commit('appendBreadcrumbs', breadcrumbs)
            this.$router.replace('/tasks')
        } else if(routePath == 'reachus') {
        } else if(routePath == 'salesCalendar') {
            this.show_calendar = true
            this.production_calendar = false
        } else if(routePath == 'productionCalendar') {
            this.show_calendar = true
            this.production_calendar = true
        } else if(routePath == 'stocksearch') {
            this.displayMenu()
            this.show_stock_search = true
        } else if(routePath == 'addtask') {
            this.displayMenu()
            this.newTask()
        } else {
          let routeIndex = this.$store.getters.getAllMenus.findIndex((t) => t.route_path == routePath)
          let canMoveForward = false
          if(routeIndex>=0) {
            let routeAccessInfo = this.$store.getters.getAllMenus[routeIndex]
            if(routeAccessInfo.can_view) {
              canMoveForward = true
            }
            this.$store.commit('setAccessRights', routeAccessInfo)
          }
          if(canMoveForward) {
            breadcrumbs.push({
                crumbName: this.$store.getters.getAllMenus[routeIndex].menu_name
            })
            this.$store.commit('appendBreadcrumbs', breadcrumbs)
            this.$router.replace(routePath)
          } else {
            this.$store.commit('displayMessageAlert', {message: 'Access Denied', type: 'Error'})    
          }
          
        }
        },
      logout() {
        this.$confirm('Are you sure to logout?', 'Warning', {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            type: 'warning'
        }).then(() => {
            this.$store.dispatch('logout')
        }).catch(() => {
                   
        });
      },
      loadPageAccess() {
        let routePath = this.$router.currentRoute.path
        let routeIndex = this.$store.getters.getAllMenus.findIndex((t) => t.route_path == routePath)
        let canMoveForward = false
        if(routeIndex>=0) {
          let routeAccessInfo = this.$store.getters.getAllMenus[routeIndex]
          if(routeAccessInfo.can_view) {
            canMoveForward = true
          }
          this.$store.commit('setAccessRights', routeAccessInfo)
        }
        if(canMoveForward) {
          let breadcrumbs = [{
              crumbName: this.$store.getters.getAllMenus[routeIndex].menu_name
          }]
          this.$store.commit('appendBreadcrumbs', breadcrumbs)
        } else {
          //this.$store.commit('displayMessageAlert', {message: 'Access Denied', type: 'Error'})    
          this.$router.replace('/')
        }
      }
    },
    mounted() {
      this.$store.dispatch('fetchPreferences')
      this.$store.state.tasks.show_task_form = false
      this.$store.dispatch('fetchTaskCategoryList')
      this.$store.dispatch('fetchEmployeeMasterList', {store_list: this.$store.getters.getAccessibleStoreList})
        
      setTimeout(() => {
        if(this.isMobileDevice) {
          this.show_menu = false
        } else {
          this.show_menu = true
        }

        this.loadPageAccess()

      }, 1000);
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/MainMenu.vue